// return data from the store, act similar as computed variable
const moduleGetters = {
  getEvents: state => {
    return state.events;
  },
  getRoomEvents: state => roomId => {
    return state.events[roomId];
  }
};

export default moduleGetters;
